'use client'

import React from 'react'
import { Col, Row } from '../../atoms/GridSystem'

import PostBody from '../../molecules/PostBody/PostBody.component'

import * as S from './PostContent.styles'

const PostContent = ({ sectionsBody }) => {
  
  return (
    <S.PostContent>
      <Row>
        <Col xs={12}>
          <PostBody sections={sectionsBody} />
        </Col>
      </Row>
    </S.PostContent>
  )
}

export default PostContent
